import React, { useState, useEffect, useMemo } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaBan, FaCheck, FaExclamationTriangle } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import { bin2hex, extract, parseCamposQuestionario, isTipoPalestrante } from '../../../util/util';
import { toast } from 'react-toastify';
import MostrarHTML from '../../../components/MostrarHtml';
import { getText, getIdiomaCodigo } from '../../../util/translations';
import { getAuthPerfil, getAuthToken } from '../../../util/authSession';
import '../../../css/financeiro-parcela-pagar.css';
import { rotaDoStep, irParaProximoStep } from '../../../util/fluxoConvite';


export default function CadastroEventoParticipanteAceitarConvite({ match }) {
    let elementoAssinatura = null;
    const id = match.params.id;
    const token = getAuthToken();
    const perfil = getAuthPerfil();
    const [data, setData] = useState(null);
    const [concordaConvite, setConcordaConvite] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    // Modelo da carta barrado pela trava do evento: troca o card vazio por um aviso traduzido.
    const [cartaIndisponivel, setCartaIndisponivel] = useState(false);
    const [cpfInicial, setCpfInicial] = useState(null);
    const history = useHistory();
    const { state } = useLocation();
    const idioma = getIdiomaCodigo();
    const params = new URLSearchParams(window.location.search);
    const contrato = params.get('contrato');
    const shouldShowVinculoOrgaoPublico = (data?.evento?.camposQuestionario?.vinculoOrgaoPublico ?? "nao") === "sim";
    const tipoparticipanteId = data?.tipoparticipante?.id ?? data?.tipoparticipante;
    const palestranteApenasVisualiza = ["abbvie", "allergan"].includes(data?.evento?.cliente?.modelo ?? "") && isTipoPalestrante(tipoparticipanteId);

    const splitHtmlCartaConvite = (htmlCarta) => {
        const placeholder = '<div data-vinculo-orgao-publico-placeholder="true"></div>';
        const html = htmlCarta ?? '';

        if (html.trim() === '') {
            return { beforeHtml: '', afterHtml: '', shouldInline: false };
        }

        const patterns = [
            /Como condiÃ§Ã£o ao oferecimento do apoio[\s\S]*?<span style="border:\s*1px solid black;\s*display:\s*block;\s*min-height:\s*60px;\s*padding:\s*5px;">[\s\S]*?<\/span>/iu,
            /\([X ]\)\s*NÃ£o possui qualquer espÃ©cie de vÃ­nculo com Ã“rgÃ£o PÃºblico\.<br>\s*\([X ]\)\s*PossuÃ­ vÃ­nculo com Ã“rgÃ£o PÃºblico, mesmo que de forma indireta\.<br>\s*\([X ]\)\s*Outros\. Especifique:<br>\s*<span style="border:\s*1px solid black;\s*display:\s*block;\s*min-height:\s*60px;\s*padding:\s*5px;">[\s\S]*?<\/span>/iu,
        ];

        for (const pattern of patterns) {
            if (!pattern.test(html)) {
                continue;
            }

            const htmlWithPlaceholder = html.replace(pattern, placeholder);
            const [beforeHtml, afterHtml = ''] = htmlWithPlaceholder.split(placeholder);
            return { beforeHtml, afterHtml, shouldInline: true };
        }

        return { beforeHtml: html, afterHtml: '', shouldInline: false };
    };

    const cartaHtmlPartes = useMemo(
        () => splitHtmlCartaConvite(data?.htmlCartaConvite),
        [data?.htmlCartaConvite]
    );

    const renderVinculoOrgaoPublico = () => (
        <div
            style={{
                margin: '12px 0 24px',
                maxWidth: '820px',
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <label
                    style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '12px',
                        margin: 0,
                        fontSize: '18px',
                        lineHeight: 1.35,
                        cursor: 'pointer',
                    }}
                >
                    <input
                        type="radio"
                        name="vinculoOrgaoPublico"
                        value="nao"
                        checked={data?.vinculoOrgaoPublico === "nao"}
                        onChange={() => {
                            data.vinculoOrgaoPublico = "nao";
                            data.especificacaoVinculo = "";
                            setData({ ...data });
                        }}
                        style={{ marginTop: '4px', width: '18px', height: '18px', flexShrink: 0 }}
                    />
                    <span>{getText('noVinculoOrgaoPublico')}</span>
                </label>

                <label
                    style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '12px',
                        margin: 0,
                        fontSize: '18px',
                        lineHeight: 1.35,
                        cursor: 'pointer',
                    }}
                >
                    <input
                        id="vinculoOrgaoPublico"
                        type="radio"
                        name="vinculoOrgaoPublico"
                        value="sim"
                        checked={data?.vinculoOrgaoPublico === "sim"}
                        onChange={() => {
                            data.vinculoOrgaoPublico = "sim";
                            setData({ ...data });
                        }}
                        style={{ marginTop: '4px', width: '18px', height: '18px', flexShrink: 0 }}
                    />
                    <span>{getText('vinculoOrgaoPublico')}</span>
                </label>

                <label
                    style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '12px',
                        margin: 0,
                        fontSize: '18px',
                        lineHeight: 1.35,
                        cursor: 'pointer',
                    }}
                >
                    <input
                        type="radio"
                        name="vinculoOrgaoPublico"
                        value="outro"
                        checked={data?.vinculoOrgaoPublico === "outro"}
                        onChange={() => {
                            data.vinculoOrgaoPublico = "outro";
                            setData({ ...data });
                        }}
                        style={{ marginTop: '4px', width: '18px', height: '18px', flexShrink: 0 }}
                    />
                    <span>{getText('otherVinculoOrgaoPublico')}</span>
                </label>
            </div>

            <textarea
                className="form-control"
                rows="5"
                placeholder={getText('specifyVinculoOrgaoPublico')}
                value={data?.especificacaoVinculo || ''}
                onChange={(e) => {
                    data.especificacaoVinculo = e.target.value;
                    setData({ ...data });
                }}
                style={{
                    marginTop: '20px',
                    borderRadius: '14px',
                    minHeight: '180px',
                    fontSize: '16px',
                    padding: '18px 20px',
                }}
            />
        </div>
    );

    const buscar = () => {
        setIsLoading(true);
        setIsError(false);
        setCartaIndisponivel(false);
        api({
            method: "get",
            action: '/participante/' + id,
            token: token,
        }).then(response => {
            //extrai dados internos para o array principal
            var dadosRecebidos = extract({
                jsonLaravel: response.data.data,
                chaves: [
                    'enderecopais',
                    'aereomunicipioembarque',
                    'enderecomunicipio',
                    'banco',
                ]
            });

            // Armazena o CPF inicial
            setCpfInicial(dadosRecebidos.cpf || '');

            dadosRecebidos.evento.camposQuestionario = parseCamposQuestionario(dadosRecebidos?.evento?.camposQuestionario);

            // o back decide a etapa (proximoStep). Se esta tela ('carta') não é a etapa atual, redireciona.
            if (dadosRecebidos.proximoStep !== 'carta') {
                history.push(rotaDoStep(dadosRecebidos.proximoStep, { id, eventoId: dadosRecebidos.evento.id, contrato }));
                return;
            }

            // Para o cliente "access", aceita automaticamente (sem mostrar a tela) e segue.
            if ((dadosRecebidos.evento?.cliente?.modelo ?? "") === "access") {
                api({
                    method: 'put',
                    action: '/participante/aceitarConvite/' + id,
                    token: token,
                    data: {
                        aceitouConvite: 'sim',
                        contrato: contrato ? 'sim' : 'nao',
                        vinculoOrgaoPublico: null,
                        especificacaoVinculo: null,
                        cpf: null,
                        imagemassinatura: null,
                        binarioImagemAssinatura: null,
                    },
                })
                    .then(() => irParaProximoStep(history, { id, token, eventoId: dadosRecebidos.evento.id, contrato, setLoading: setIsLoading }))
                    .catch(() => {
                        // Se o auto-aceite falhar, NÃO re-rotear (o back devolveria 'carta' de novo →
                        // navega pra mesma rota, não remonta, trava no overlay). Sinaliza erro.
                        setIsLoading(false);
                        setIsError(true);
                        toast.error(`${getText('error')} ${getText('errorLoadingDefault')}`);
                    });
                return;
            }

            // é a etapa da carta e não é "access": mostra a carta (busca o HTML).
            api({
                method: "get",
                action: '/eventoCarta/visualizarCartaHtml/' + id,
                token: token,
                params: {
                    tipoCarta: "modelocartaconvite",
                }
            }).then(response => {
                setData({
                    ...dadosRecebidos,
                    ...{
                        htmlCartaConvite: response.data.data.htmlCarta,
                        vinculoOrgaoPublico: null,
                        especificacaoVinculo: '',
                    }
                });
                setIsLoading(false);
            }).catch(function (error) {
                // A trava de seguranca do evento barrou o modelo desta carta: a API responde com
                // `code: carta_indisponivel`. Aviso fixo e traduzido dentro do card — o toast
                // generico fechava em 3,5 s e deixava o convidado diante de um card vazio, sem
                // saber que precisa falar com a organizacao do evento.
                if (error?.response?.data?.code === 'carta_indisponivel') {
                    setCartaIndisponivel(true);
                } else {
                    toast.error(`${getText('error')} ${getText('errorLoadingDefault')}`);
                }
                setIsLoading(false);
                setIsError(true);
            });
        }).catch(function (error) {
            setIsLoading(false);
            setIsError(true);
            toast.error(`${getText('error')} ${getText('errorLoadingDefault')}`);
        });
    };//buscar

    const validar = () => {
        if ((data?.evento?.camposQuestionario?.vinculoOrgaoPublico ?? "nao") === "sim") {
            var vinculoOrgaoPublico = document.querySelector("#vinculoOrgaoPublico");
            if ((data?.vinculoOrgaoPublico ?? '') === '') {
                toast.error(getText('requiredVinculoOrgaoPublico'));
                setTimeout(() => {
                    vinculoOrgaoPublico.focus();
                }, 500);
                return false;
            }

            // ValidaÃ§Ã£o para especificaÃ§Ã£o do vÃ­nculo
            if ((data?.vinculoOrgaoPublico === 'sim' || data?.vinculoOrgaoPublico === 'outro') &&
                (!data?.especificacaoVinculo || data?.especificacaoVinculo.trim() === '')) {
                toast.error(getText('specifyVinculoOrgaoPublico'));
                return false;
            }
        }

        // ValidaÃ§Ã£o do CPF
        if (((data?.evento?.camposQuestionario?.cpfAssinatura ?? "nao") === "sim") &&
            (!data?.cpf || data?.cpf.trim() === '')) {
            toast.error(getText('requiredCpf'));
            setTimeout(() => {
                document.getElementById('cpf').focus();
            }, 500);
            return false;
        }

        return true;
    };

    const continuar = () => {
        // Palestrante abbvie/allergan (carta view-only): carimba que VIU a carta (datacartavisualizada)
        // e segue. Sem assinar — o carimbo faz a carta deixar de ser pendente sem entrar em loop.
        setIsLoading(true);
        api({ method: 'put', action: '/participante/' + id + '/visualizarCarta', token: token })
            .then(() => {
                irParaProximoStep(history, { id, token, eventoId: data?.evento?.id, contrato, setLoading: setIsLoading });
            })
            .catch(() => {
                setIsLoading(false);
                toast.error(getText('error') + getText('errorRefreshPage'));
            });
    }; //continuar

    const salvar = async (aceitouConvite) => {
        if (!validar()) {
            return false;
        }

        setIsSubmitting(true);

        api({
            method: 'put',
            action: '/participante/aceitarConvite/' + id,
            token: token,
            data: {
                aceitouConvite: aceitouConvite ? 'sim' : 'nao',
                contrato: contrato ? 'sim' : 'nao',
                vinculoOrgaoPublico: data?.vinculoOrgaoPublico ?? null,
                especificacaoVinculo: data?.especificacaoVinculo ?? null,
                cpf: data?.cpf ?? null,
                imagemassinatura: data?.imagemassinatura ?? null,
                binarioImagemAssinatura: elementoAssinatura ? bin2hex(elementoAssinatura.getCanvas().toDataURL('image/png')) : null
            },
        })
            .then(function (response) {
                toast.success(getText('dadosSalvosSucesso'));
                if (!aceitouConvite) {
                    history.push("/cadastroEventoParticipanteConviteRecusado/" + data?.evento?.id);
                    return;
                }
                if (contrato) {
                    history.push("/cadastroEventoParticipanteContratoEnviado/" + (data?.evento?.id ?? ""));
                    return;
                }
                //aceite normal: o back resolve a próxima etapa (com overlay de load durante o GET).
                irParaProximoStep(history, { id, token, eventoId: data?.evento?.id, contrato, setLoading: setIsLoading });
            })
            .catch(function (error) {
                toast.error(`${getText('error')} ${getText('errorSavingDefault')}`);
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    useEffect(() => { //onload
        if (data?.base64assinatura) {
            if (elementoAssinatura)
                elementoAssinatura.fromDataURL("data:image/png;base64," + data.base64assinatura, { ratio: 1 });
        }
    },
        // eslint-disable-next-line
        [data?.base64assinatura]);

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate sidebar={['listarsvp', 'cliente'].includes(perfil) ? false : true} processando={isLoading} idioma={idioma ?? "both"}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h2 className="fin-pp__title">{getText('aceitarConvite')}</h2>
                    </div>
                </div>
                <div className="fin-pp__card" style={{ padding: '16px' }}>
                    {/* Carta HTML - mantida com seus estilos */}
                    {cartaIndisponivel && (
                        <div className="fin-pp__banner is-warn">
                            <FaExclamationTriangle size={16} className="fin-pp__banner-ic" />
                            <span>{getText('cartaIndisponivel')}</span>
                        </div>
                    )}
                    <MostrarHTML htmlContent={cartaHtmlPartes.beforeHtml ?? null} />
                    {shouldShowVinculoOrgaoPublico && cartaHtmlPartes.shouldInline ? renderVinculoOrgaoPublico() : null}
                    <MostrarHTML htmlContent={cartaHtmlPartes.afterHtml ?? null} />

                    {!isLoading && !isError && data?.evento && (
                        <>
                            {shouldShowVinculoOrgaoPublico && !cartaHtmlPartes.shouldInline ? (
                                <div style={{ marginBottom: 20 }}>
                                    {renderVinculoOrgaoPublico()}
                                </div>
                            ) : null}

                            {(data?.evento?.camposQuestionario?.cpfAssinatura === "sim" && (!cpfInicial || cpfInicial.trim() === '')) && (
                                <div style={{ marginTop: 20, maxWidth: 400 }}>
                                    <div className="fin-pp__filters">
                                        <div style={{ gridColumn: '1 / -1' }}>
                                            {/* Manter o input nativo pois tem id="cpf" usado por document.getElementById */}
                                            <label htmlFor="cpf" style={{ display: 'block', marginBottom: 4 }}>{getText('cpf')} *</label>
                                            <input
                                                type="text"
                                                className="fin-pp__input"
                                                id="cpf"
                                                placeholder={getText('enterCpf')}
                                                value={data?.cpf || ''}
                                                onChange={(e) => {
                                                    data.cpf = e.target.value;
                                                    setData({ ...data });
                                                }}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {palestranteApenasVisualiza ? (
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                                    <button
                                        type="button"
                                        className="fin-pp__btn fin-pp__btn--primary"
                                        onClick={continuar}
                                    >
                                        <FaCheck size={16} /> {getText('next')}
                                    </button>
                                </div>
                            ) : (
                                <>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                                            <input type="checkbox"
                                                value={concordaConvite}
                                                checked={concordaConvite}
                                                onChange={(value) => {
                                                    setConcordaConvite(!concordaConvite);
                                                }} />
                                            {getText('agreeWithTerms')}
                                        </label>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 }}>
                                        <button
                                            type="button"
                                            className="fin-pp__btn fin-pp__btn--danger"
                                            disabled={isSubmitting}
                                            onClick={() => { salvar(false); }}
                                        >
                                            {isSubmitting ? (
                                                <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>{getText('salvando')}</>
                                            ) : (
                                                <><FaBan size={16} /> {getText('declineInvite')}</>
                                            )}
                                        </button>
                                        <button
                                            type="submit"
                                            className="fin-pp__btn fin-pp__btn--primary"
                                            disabled={!concordaConvite || isSubmitting || !data?.htmlCartaConvite}
                                            onClick={() => { salvar(true); }}
                                        >
                                            {isSubmitting ? (
                                                <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>{getText('salvando')}</>
                                            ) : (
                                                <><FaCheck size={16} /> {getText('acceptInvite')}</>
                                            )}
                                        </button>
                                    </div>
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        </ErpTemplate>
    );
}
